(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["firework-embed"] && !Shopify.designMode) return;
  try {
    
  /* This function is required for the floating player and floating button.
  Shopify's page-builder places these DOM nodes in a weird way that blocks
  the static positioning from working properly. Moving the node to be a
  direct child of <body> makes it work properly. */

  var element = document.getElementById('move-to-body');
  if (element) {
    document.querySelector('body').appendChild(element);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const swiperElement = document.querySelector('.testimonial-slider .swiper-container');
    if (swiperElement) {
      new Swiper(swiperElement, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 10,
        autoplay: {
          delay: 2500
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 10
          },
          767: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 10
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 20
          }
        }
      });

      const swiper = document.querySelector('.swiper-container').swiper;
      if (swiper) {
        swiper.update();
      }
    } else {
      console.error('Swiper container not found!');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const swiperElement = document.querySelector('.testimonial-slider .swiper-container');
    if (swiperElement) {
      new Swiper(swiperElement, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 10,
        autoplay: {
          delay: 2500
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 10
          },
          767: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 10
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 20
          }
        }
      });

      const swiper = document.querySelector('.swiper-container').swiper;
      if (swiper) {
        swiper.update();
      }
    } else {
      console.error('Swiper container not found!');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
